import React from 'react';
import {
  formatOmdPrice,
  taxCodeToVatPercent,
  type OmdProduct,
} from '../../../utils/omdProductView';

type OmdPriceHeroCardProps = {
  product: OmdProduct;
};

export function OmdPriceHeroCard({ product }: OmdPriceHeroCardProps) {
  const netFormatted = formatOmdPrice(product.prices?.netPrice);
  const listFormatted = formatOmdPrice(product.prices?.listPrice);
  const vat = taxCodeToVatPercent(product.prices?.taxCode);
  const delivery = product.logistics?.standardDeliveryPeriod;

  if (product.basic?.priceOnDemand) {
    return (
      <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
        <p className="text-sm font-medium text-amber-800">Preis nur auf Anfrage</p>
      </div>
    );
  }

  if (!netFormatted && !listFormatted) return null;

  return (
    <div className="rounded-lg border border-app-border bg-app-surface px-4 py-3">
      <div className={`grid gap-4 ${listFormatted ? 'grid-cols-2' : 'grid-cols-1'}`}>
        <div>
          <p className="text-xs font-medium text-app-text-muted">Netto-EK</p>
          {netFormatted ? (
            <p className="mt-1 text-xl font-semibold tabular-nums text-pipedrive-blue">{netFormatted}</p>
          ) : (
            <p className="mt-1 text-xl font-semibold text-app-text-subtle">-</p>
          )}
        </div>
        {listFormatted && (
          <div>
            <p className="text-xs font-medium text-app-text-muted">Netto Listenpreis</p>
            <p className="mt-1 text-xl font-semibold tabular-nums text-app-text">{listFormatted}</p>
          </div>
        )}
      </div>
      <p className="text-xs text-app-text-subtle mt-2">zzgl. {vat} % MwSt.</p>
      {delivery != null && delivery !== '' && (
        <p className="mt-2 text-xs text-app-text-subtle">Lieferzeit: {String(delivery)}</p>
      )}
    </div>
  );
}
